const CLI_CALLBACK_PORTS = new Set(['8765', '8766', '8767']);

export function isAllowedCliRedirect(value: string): boolean {
    try {
        const url = new URL(value);
        return url.protocol === 'http:'
            && url.hostname === 'localhost'
            && CLI_CALLBACK_PORTS.has(url.port)
            && url.pathname === '/callback'
            && !url.username
            && !url.password
            && !url.search
            && !url.hash;
    } catch (_) {
        return false;
    }
}

export function buildCliCallbackUrl(redirect: string, state: string, cookie: string): string | null {
    if (!isAllowedCliRedirect(redirect) || !/^[a-f0-9]{64}$/.test(state)) {
        return null;
    }
    const url = new URL(redirect);
    url.searchParams.set('state', state);
    url.searchParams.set('c', cookie);
    return url.toString();
}
